import React from 'react';
import { useHistory } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { Box, ListItemIcon, MenuItem, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import DownloadIcon from '@mui/icons-material/Download';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import CustomMaterialMenu from '../../../modules/dataTable/rowMenu/CustomMaterialMenu';
import { AutoTreatRealTimeActivityContext } from '../../../autotreatModules/realTimeDashboard/contexts/AutoTreatRealTimeActivityContext';
import { AutoBulkTransactionsContext } from '../contexts/AutoBulkTransactionsContext';
import ConfirmCancelModal from '../../../modules/shared/modal/ConfirmCancelModal';
import FormInput from '../../../modules/shared/form/FormInput';

interface TransactionRowMenuProps {
  transaction: any;
}

const useStyles = makeStyles(() => ({
  listItemIcon: {
    minWidth: '24px',
  },
}));

const TransactionRowMenu: React.FC<TransactionRowMenuProps> = (props: TransactionRowMenuProps) => {
  const { transaction } = props;
  const classes = useStyles();
  const history = useHistory();
  const { user } = useAuth0();
  const { setDisplayApiResponseModal } = React.useContext(AutoTreatRealTimeActivityContext);
  const { emailTransaction } = React.useContext(AutoBulkTransactionsContext);
  const [modalOpen, setModalOpen] = React.useState<boolean>(false);
  const [destEmail, setDestEmail] = React.useState<string>('');

  const handleEmail = async () => {
    emailTransaction(transaction.work_order_transaction_guid, destEmail, new Date().getTimezoneOffset(), () =>
      setModalOpen(false),
    );
  };

  return (
    <Box>
      <ConfirmCancelModal
        isOpen={modalOpen}
        onCancel={() => setModalOpen(false)}
        onConfirm={handleEmail}
        closeOnConfirm
        title="Email Transaction Receipt"
        hasFooterBar
        confirmLabel="Send Email"
      >
        <div style={{ margin: '10px 20px' }}>
          <Typography style={{ marginLeft: -15 }} variant="h2" component="h2">
            Email the transaction receipt for Transaction {transaction?.work_order_name}?
          </Typography>
          <br />
          <FormInput value={destEmail} onChange={(value) => setDestEmail(value)} label="Email" />
        </div>
      </ConfirmCancelModal>
      <CustomMaterialMenu size="medium">
        <div />
        <MenuItem
          onClick={() =>
            window.open(
              `${process.env.REACT_APP_API_ENDPOINT}/api/autobulk/analytics/transactions/pdf?id=${
                transaction.work_order_transaction_guid
              }&email=${user?.email}&utcOffset=${new Date().getTimezoneOffset()}`,
              '_blank',
              'noreferrer',
            )
          }
        >
          <ListItemIcon className={classes.listItemIcon}>
            <DownloadIcon fontSize="small" color="secondary" />
          </ListItemIcon>
          <Typography variant="inherit">Download Receipt</Typography>
        </MenuItem>
        <MenuItem onClick={() => setModalOpen(true)}>
          <ListItemIcon className={classes.listItemIcon}>
            <AttachEmailIcon fontSize="small" color="secondary" />
          </ListItemIcon>
          <Typography variant="inherit">Email Receipt</Typography>
        </MenuItem>
      </CustomMaterialMenu>
    </Box>
  );
};

export default TransactionRowMenu;
